import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "./reduxStore";

interface OrderState {
  selectedPracticeIds: number[];
}

const initialState: () => OrderState = () => {
  return {
    selectedPracticeIds: [],
  };
};

const orderStateSlice = createSlice({
  name: "orderState",
  initialState: initialState(),
  reducers: {
    setSelectedPracticeIds: (
      state: OrderState,
      action: PayloadAction<number[]>,
    ) => {
      state.selectedPracticeIds = action.payload;
    },
  },
});

export const { setSelectedPracticeIds } = orderStateSlice.actions;

export const selectSelectedPracticeIds = (state: RootState) =>
  state.orderState.selectedPracticeIds;

export default orderStateSlice.reducer;
